<template>
  <div>
    <v-row justify="center" class="mt-1">
      <v-col cols="8" lg="8" sm="12" md="12" class="pt-0 mt-0">
        <v-data-table dense :headers="headers" :items="items" :loading="loadingTable" :group-by="'gender'"
          :footer-props="{
            'items-per-page-options': [50, 100, 150, 200],
          }" fixed-header height="70vh" :search="search" disable-sort hide-default-header>
          <template v-slot:header="{ props: { headers } }">
            <thead>
              <tr>
                <th class="footer" v-for="(h, i) in headers" :key="i">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <span v-on="on">{{ h.text }}</span>
                    </template>
                    <span>{{ h.text }}</span>
                  </v-tooltip>
                </th>
                <th class="footer">
                  <v-tooltip right>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on" @click="sortData">mdi-sort</v-icon>
                    </template>
                    <span>Sort</span>
                  </v-tooltip>
                </th>
              </tr>
            </thead>
          </template>
          <template v-slot:group.header="{ items, isOpen, toggle }">
            <th colspan="11" :class="$vuetify.theme.dark ? '' : 'green lighten-4'">
              <v-icon @click="toggle">{{ isOpen ? "mdi-minus" : "mdi-plus" }}
              </v-icon>
              {{ items[0].gender }}
            </th>
          </template>
          <template v-slot:top>
            <v-row class="pb-1" align="center">
              <v-col cols="8" class="pl-0">
                <v-text-field v-model="search" label="Search..." class="mx-4" outlined dense hide-details="auto"
                  append-icon="mdi-magnify" color="accent"></v-text-field>
              </v-col>

              <v-spacer></v-spacer>
              <v-col cols="2">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn color="accent" v-bind="attrs" v-on="on" @click="filterData">Blanks
                      <v-icon right>{{
                        showOnlyBlanks ? "mdi-eye-off" : "mdi-eye"
                      }}</v-icon></v-btn>
                  </template>
                  <span>{{
                    showOnlyBlanks ? "Show everything" : "Show only blanks"
                  }}</span>
                </v-tooltip>
              </v-col>

              <v-col cols="2">
                <v-btn color="success" @click="saveCategories" :loading="saving" :disabled="saving">Save <v-icon
                    right>mdi-check-outline</v-icon></v-btn></v-col>
            </v-row>
          </template>
          <template v-slot:[`item.ebayCategoryId`]="{ item }">
            <tr>
              <td>
                <v-text-field dense outlined v-model="item.ebayCategoryId" hide-details="auto"
                  :rules="[rules.specialCharacters]"></v-text-field>
              </td>
            </tr>
          </template>
          <template v-slot:[`item.category`]="{ item }">
            <tr>
              <td>
                {{ item.category }}
                <span class="grey--text"> ({{ item.gender }}) </span>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <!-----------------STATUS DIALOG--------------------------------------------------->
    <v-dialog persistent v-model="statusDialog" width="unset">
      <status-info :responseMessage="responseMessage" :filename="filename" :pending="pending" @close="closeStatusDialog"
        :textColor="textColor"></status-info>
    </v-dialog>
    <!---------------------------------------------------------------------------------->
  </div>
</template>

<script>
import StatusInfo from "../organisms/StatusInfo.vue";
import axios from "axios";

export default {
  name: "EbayCategoryMapping",
  components: {
    StatusInfo,
  },
  props: {},
  computed: {},
  data: () => ({
    statusDialog: false,
    pending: false,
    responseMessage: "",
    filename: "",
    textColor: "basic--text",
    loadingTable: false,
    saving: false,
    items: [],
    notFilteredItems: [],
    genders: [],
    categories: [
      "Footwear/Sneakers",
      "Clothes/Jeans/Bootcut Jeans",
      "Clothes/Skirts/Mini Skirts",
      "Accessories/Jewellery/Bracelets",
    ],
    headers: [
      { text: "CATEGORY", value: "category", class: "footer" },
      { text: "EBAY CATEGORY", value: "ebayCategoryId", class: "footer" },
    ],
    rules: {
      specialCharacters: (v) =>
        !/[;,.]/.test(v) || "No special characters are allowed!",
    },
    search: "",
    sortedAsc: false,
    showOnlyBlanks: false,
  }),
  async mounted() {
    this.loadingTable = true;
    await this.getGenders();
    await this.getCategoriesList();
    this.items = await this.mapCategoriesToGender();
    this.notFilteredItems = [...this.items];
    await this.loadExistingMappings();
    this.loadingTable = false;
  },
  methods: {
    async getGenders() {
      try {
        const response = await this.$store.dispatch("getDropdowns");
        this.genders = response.data.gender;
      } catch (error) {
        console.log("ERROR", error);
      }
    },

    async getCategoriesList() {
      try {
        // Get category paths from Categories collection (like BCF does)
        const response = await axios.get(
          "https://bc-02.cookiejartech.lt/productsdb/api/ebay/fullCategoryPaths"
        );

        console.log("API Response:", response.data);

        if (Array.isArray(response.data)) {
          // Response is an array of objects with 'category' field
          // Extract just the category paths
          this.categories = response.data
            .map(item => item.category)
            .filter(cat => cat); // Remove any undefined

          console.log("✅ Loaded", this.categories.length, "full category paths");
          console.log("First few categories:", this.categories.slice(0, 5));
        } else {
          console.error("Unexpected response format:", response.data);
          this.categories = [];
        }
      } catch (error) {
        console.error("ERROR loading categories", error);
        this.categories = [];
      }
    },

    async loadExistingMappings() {
      try {
        // Load existing mappings from Firestore
        const response = await axios.get(
          "https://bc-02.cookiejartech.lt/productsdb/api/ebay/categoryMappings"
        );

        if (response.data && response.data.length > 0) {
          // Merge existing mappings with items
          response.data.forEach(mapping => {
            const item = this.items.find(
              i => i.category === mapping.category && i.gender === mapping.gender
            );
            if (item) {
              item.ebayCategoryId = mapping.ebayCategoryId;
            }
          });

          // Update the unfiltered items too
          this.notFilteredItems = [...this.items];
        }
      } catch (error) {
        console.log("ERROR loading existing mappings", error);
      }
    },

    //map categories to every gender
    async mapCategoriesToGender() {
      let values = [];
      for (const category of this.categories) {
        for (const gender of this.genders) {
          values.push({ gender, category, ebayCategoryId: "" });
        }
      }
      return values;
    },

    async formatCategoriesToBackend() {
      let result = {};
      result = this.items.filter((el) => el.ebayCategoryId && el.ebayCategoryId.trim() !== "");
      result = result.map((el) => {
        return {
          gender: el.gender,
          category: el.category,
          ebayCategoryId: el.ebayCategoryId.trim()
        };
      });
      return result;
    },

    async saveCategories() {
      try {
        this.saving = true;
        this.pending = true; // ✅ ADD THIS - Set pending to true at start
        this.statusDialog = true;
        this.responseMessage = "Saving category mappings...";
        this.textColor = "basic--text";

        let data = await this.formatCategoriesToBackend();

        if (data.length === 0) {
          this.responseMessage = "No categories to save. Please fill in at least one eBay category ID.";
          this.textColor = "warning--text";
          this.pending = false;
          this.saving = false;
          return;
        }

        // Call the API
        const response = await axios.post(
          "https://bc-02.cookiejartech.lt/productsdb/api/ebay/categoryIds",
          data
        );

        // Check for successful response
        if (response.status === 204 || response.status === 200) {
          const result = response.data;
          this.responseMessage = result.message || `Successfully saved ${data.length} category mapping(s)!`;
          this.textColor = "success--text";
          this.filename = ""; // Optional: clear filename or set success icon
          this.pending = false; // ✅ ADD THIS - Stop loading in success case
        } else {
          throw new Error("Unexpected response status");
        }

      } catch (error) {
        console.error("ERROR saving categories", error);
        this.responseMessage = "Failed to save category mappings. Please try again.";
        this.textColor = "error--text";
        this.filename = ""; // Optional: clear filename or set error icon
        this.pending = false; // ✅ Set pending to false AFTER setting error message
      } finally {
        this.saving = false; // Only disable the save button here
      }
    },

    closeStatusDialog() {
      this.statusDialog = false;
      this.responseMessage = "";
      this.filename = "";
    },

    //sort data so that filled categories will be on top or opposite
    sortData() {
      if (this.sortedAsc) {
        this.items = this.items.sort((a, b) => {
          if (a.ebayCategoryId == undefined && b.ebayCategoryId == undefined)
            return 0;
          if (a.ebayCategoryId == undefined) return 1;
          if (b.ebayCategoryId == undefined) return -1;
          if (a.ebayCategoryId > b.ebayCategoryId) return 1;
          if (a.ebayCategoryId < b.ebayCategoryId) return -1;
          if (a.ebayCategoryId == b.ebayCategoryId) return 0;
        });
        this.sortedAsc = false;
      } else {
        //sort categories so that categories which do not have ebayCategoryId will be on top of the list
        this.items = this.items.sort((a, b) => {
          if (a.ebayCategoryId == undefined && b.ebayCategoryId == undefined)
            return 0;
          if (a.ebayCategoryId == undefined) return -1;
          if (b.ebayCategoryId == undefined) return 1;
          if (a.ebayCategoryId > b.ebayCategoryId) return -1;
          if (a.ebayCategoryId < b.ebayCategoryId) return 1;
          if (a.ebayCategoryId == b.ebayCategoryId) return 0;
        });
        this.sortedAsc = true;
      }
    },

    //filter data , show only blank ebay categories or show everything
    filterData() {
      if (this.showOnlyBlanks) {
        this.items = [...this.notFilteredItems];
        this.showOnlyBlanks = false;
      } else {
        this.items = this.notFilteredItems.filter((item) => !item.ebayCategoryId || item.ebayCategoryId.trim() === "");
        this.showOnlyBlanks = true;
      }
    },
  },
};
</script>